/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file RiskView.jsx
 * @author Daniel Aguirre
 * @description Recommended By Scheduling View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DashboardCard from 'components/DashboardCard';
import DashboardBar from 'components/Charts/DashboardBar';
import { getMonthShortName } from 'commons/helpers/utils';
import styleGuideColors from 'commons/styleGuideColors';
import { useHistory } from 'react-router';

/**
 * Risk View
 * @param { Object } dashboardStaffActions - DashboardStaffActions Actions.
 * @return { Node } React node.
 */

function RiskView({ dashboardStaffActions, clinicId }) {
  const history = useHistory();
  const [chartData, setChartData] = useState(null);
  const { t: translate } = useTranslation();

  const { getRisk } = dashboardStaffActions;

  const onGetData = (_, resp) => {
    let labels = [];
    let dates = [];
    let months = [];
    let years = [];

    const datasets = [
      {
        label: translate('dashboardStaff.Bajo'),
        classification: 'Bajo',
        data: [],
        backgroundColor: styleGuideColors.baxterBrandTeal
      },
      {
        label: translate('dashboardStaff.Medio'),
        classification: 'Medio',
        data: [],
        backgroundColor: styleGuideColors.graphYellow
      },
      {
        label: translate('dashboardStaff.Alto'),
        classification: 'Alto',
        data: [],
        backgroundColor: styleGuideColors.alertError
      }
    ];

    if (resp?.data) {
      resp.data.forEach(({ clasificacion, cantidad, mes }) => {
        const dateSplit = mes?.split('-');
        if (dateSplit) {
          const [year, month] = dateSplit;
          const date = `${year}-${month}`;
          if (dates.indexOf(date) === -1) {
            dates = [...dates, date];
            const shortMonth = getMonthShortName(Number(month) - 1);
            labels = [...labels, translate(shortMonth)];
            years = [...years, year];
            months = [...months, month];
          }
          const findDataset = datasets.find(
            ({ classification }) => classification === clasificacion
          );
          findDataset.data = [...findDataset.data, cantidad];
        }
      });

      setChartData({
        labels,
        datasets,
        years,
        months
      });
    }
  };

  useEffect(() => {
    setChartData(null);
    getRisk({ clinicId }, onGetData);
  }, [clinicId, translate]);

  const handleDetailClick = (index, datasetIndex) => {
    const month = chartData.months[index];
    const year = chartData.years[index];
    const date = `${year}-${month}-01`;
    const totalItems = chartData.datasets[datasetIndex].data[index];
    const { classification } = chartData.datasets[datasetIndex];
    history.push(
      `/main/dashboard-detail/risk/${classification}/${date}/${totalItems}`
    );
  };
  return (
    <DashboardCard id="F17" loading={!chartData} colSpan={1}>
      <DashboardBar
        title={translate('dashboardStaff.risk')}
        yTitle={translate('dashboardStaff.numberOfPatients')}
        dataValues={chartData}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
RiskView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getRisk: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default RiskView;
